module.exports = "<div class=\"card toggle-button session-student-label small-grey-text\">\n  <p data-bind-target=\"mission-label-name\"></p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/views/partials/missions/mission-label.html
// module id = 626
// module chunks = 1